import {Button, Form, Input} from 'antd';
import {useState} from 'react';
// import {InstagramEmbed} from 'react-social-media-embed';

import {AboutUs} from './AboutUs';

const AboutUsScreen = () => {

  return (
    <div className={'flex flex-col justify-center items-center w-full '}>
      <AboutUs />
      {/* <div style={{display: 'flex', justifyContent: 'center'}}>
        <InstagramEmbed 
          url={'https://www.instagram.com/p/DT2mMNMj5hv/?img_index=1'} 
          width={700} 
          captioned 
        />
      </div> */}
    </div>
  );
};

export default AboutUsScreen;
